import React from 'react';

import { Title } from 'shared';
import { Dashboard } from 'features/dashboard/components/Dashboard';

const DashboardPage = () => {
  return (
    <>
      <Title title="Dashboard" />
      <Dashboard />
    </>
  );
};

export default DashboardPage;
